// removed by extract-text-webpack-plugin
module.exports = {"detail":"_1Fv-nzk13lMXuCau5_X4rC"};


//////////////////
// WEBPACK FOOTER
// ./src/components/customerDetailCard/styles.css
// module id = 1536
// module chunks = 0